import { connect } from 'react-redux';

import AppMenu, { StateProps } from './app-menu';
import { getAppMenu } from 'client/ducks/app/selectors';
import { getCurrentPathname } from 'client/ducks/router/selectors';
import { State } from 'client/store';

function mapStateToProps(state: State): StateProps {
    return {
        links: getAppMenu(state),
        // Прокидывает pathname что-бы компонент обновлялся при смене страницы
        pathname: getCurrentPathname(state)
    };
}

export default connect<StateProps>(mapStateToProps)(AppMenu) as any;
